import { type WrappedInsightAgentRequestDiversityAttributes } from "@clipboard-health/contract-backend-main";
import { Image, Span, Text } from "@clipboard-health/ui-components";
import { Box, Stack } from "@mui/material";

import badgeIcon from "../../assets/badge-wrapped.png";

interface WorkerShiftTypeDiversityContentProps {
  attributes: WrappedInsightAgentRequestDiversityAttributes;
}

export function WorkerShiftTypeDiversityContent(props: WorkerShiftTypeDiversityContentProps) {
  const { attributes } = props;

  const hasSecondaryShiftTypes =
    attributes.secondMostWorkedShiftType && attributes.thirdMostWorkedShiftType;

  return (
    <Stack flex={1} position="relative" overflow="hidden">
      {/* Text section - top */}
      <Stack
        position="absolute"
        sx={{
          top: "10%",
          left: "7.7%",
          right: "7.7%",
        }}
        spacing={8}
      >
        <Text variant="body1" color="white">
          Trying new things must be easy for you.
        </Text>

        <Stack gap={1}>
          <Text variant="body1" color="white">
            You worked most of your shifts as a
          </Text>
          <Text variant="h1" color="white" sx={{ fontSize: "4rem", lineHeight: 1 }}>
            {attributes.mostWorkedShiftType}
          </Text>
        </Stack>

        {hasSecondaryShiftTypes && (
          <Stack gap={1}>
            <Text variant="body1" color="white">
              You also picked up work as a
            </Text>
            <Text variant="body1" color="white">
              <Span sx={{ fontSize: "1.25rem" }}>{attributes.secondMostWorkedShiftType}</Span> and{" "}
              <Span sx={{ fontSize: "1.25rem" }}>{attributes.thirdMostWorkedShiftType}</Span> this
              year.
            </Text>
          </Stack>
        )}
      </Stack>

      {/* Badge with radial glow - positioned based on Figma */}
      <Box
        position="absolute"
        sx={{
          top: "50%", // 406 / 812
          left: "1.9%", // 7 / 375
        }}
      >
        {/* Radial white glow effect */}
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "120%",
            height: "120%",
            background:
              "radial-gradient(circle, rgba(255,255,255,0.6) 0%, rgba(255,255,255,0.3) 30%, rgba(255,255,255,0) 70%)",
            pointerEvents: "none",
          }}
        />
        <Image
          src={badgeIcon}
          alt="Badge"
          width="87vw" // 326 / 375
          height="auto"
          sx={{ position: "relative" }}
        />
      </Box>
    </Stack>
  );
}
